// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback} from 'react';
import cn from 'classnames';
import etask from '/util/etask.js';
import {stop_mimic} from '@pub/store/user.js';
import {mimic_by_query} from '@pub/utils/user.js';
import {Button} from '@pub/comp/button';
import {Text} from '@pub/comp/text';
import {User} from '@pub/comp/user';
import {read_clipboard} from '@pub/utils/clipboard';
import * as cns from './selected_user.module.less';

export function Selected_user({user, className, center_content}){
    const handle_paste = useCallback(()=>etask(function*(){
        const value = yield read_clipboard();
        mimic_by_query(value);
    }), []);
    return <div className={cn(cns.root, className)}>
      <Button color_scheme="tertiary" filled size="s" ico="paste"
        tip="Paste new user search query" on_click={handle_paste}/>
      {!!user&&<>
        <User user={user} tip={<>
          <Text.xs bold>Selected user</Text.xs>
          <Text.xs secondary mono>email: {user.email}</Text.xs>
          {!!user._id&&<Text.xs secondary mono>id: {user._id}</Text.xs>}
        </>}/>
        {center_content}
        <Button color_scheme="tertiary" filled size="s" ico="close"
          on_click={stop_mimic} tip="Clear"/>
      </>}
    </div>;
}
